import React from 'react';
import { Select } from 'antd';
import * as S from './styles';

export function SelectMultiplo({ ...props }) {
  return (
    <S.RowStyles style={{ width: '100%' }} iconColor={props?.iconColor}>
      <Select mode="multiple" {...props} />
    </S.RowStyles>
  );
}
